export const QA_NAME_APPLICANT_CREATION_MODAL = 'createApplicant'
